import cn from 'clsx'
import type { Track } from 'types/track'
import { createNestedSetLocation } from '@disco/utils/nesting'
import { selectionContainNestedTracks } from '@disco/utils/selection'

const itemClass = (nestedTrackHaveSelected: boolean, disabled?: boolean) => {
  return cn('context-menu__option', {
    'is-disabled': nestedTrackHaveSelected || disabled,
  })
}

export const getShortlistEnabledClasses = (props: {
  selectedItems: Track[]
  selectedItemsWithinUserTerritories: Track[]
  shortlistsCount: number
}): {
  mergeEnabledClass: string
  actionEnabledClass: string
  editSelectedClass: string
  addToChannelClass: string
  deleteActionEnabledClass: string
  shortlistActionEnabledClass: string
  manageNestingClass: string
} => {
  const { selectedItems, selectedItemsWithinUserTerritories, shortlistsCount } =
    props
  const nestedTrackHaveSelected =
    selectionContainNestedTracks(selectedItems) && selectedItems.length > 1
  const boundItemClass = itemClass.bind(null, nestedTrackHaveSelected)
  const selectionContainsNotProcessedTracks =
    selectedItems.filter(track => !track.uploaded).length > 0
  const disableActionProcessing =
    selectedItemsWithinUserTerritories.length === 0 ||
    selectionContainsNotProcessedTracks
  const mergeEnabledClass = boundItemClass(
    selectedItemsWithinUserTerritories.length < 2 ||
      selectionContainsNotProcessedTracks,
  )
  const actionEnabledClass = boundItemClass(selectedItems.length === 0)
  const shortlistActionEnabledClass = boundItemClass(
    shortlistsCount < 2 || selectedItems.length === 0,
  )
  const editSelectedClass = boundItemClass(disableActionProcessing)
  const addToChannelClass = boundItemClass(disableActionProcessing)
  // Only delete option available if selectedItems contains nested tracks
  const deleteActionEnabledClass = itemClass(disableActionProcessing)
  const manageNestingClass = itemClass(
    false,
    !Boolean(createNestedSetLocation(selectedItems)),
  )
  return {
    mergeEnabledClass,
    actionEnabledClass,
    editSelectedClass,
    addToChannelClass,
    deleteActionEnabledClass,
    shortlistActionEnabledClass,
    manageNestingClass,
  }
}
